import React from "react";
import "../styles/Footer.css";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaInstagram,
} from "react-icons/fa"; // Import icons
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-top">
        {/* Quick Links */}
        <div className="footer-links">
          <h3>Quick Links</h3>
          <ul>
            <li>
            <Link to="/" className="nav-item">
            HOME
          </Link>            </li>
            <li>
            <Link to="/about-us" className="nav-item">
            ABOUT US
          </Link>
            </li>
            <li>
            <Link to="/services" className="nav-item">
            SERVICES
          </Link>
            </li>
            <li>
            <Link to="/our-team" className="nav-item">
            OUR TEAM
          </Link>
            </li>
            <li>
            <Link to="/contact" className="nav-item">
            CONTACT
          </Link>
            </li>
            <li>
            <Link to="/" className="nav-item">
            CAREERS
          </Link>
            </li>
            <li>
            <Link to="/" className="nav-item">
            BLOG
          </Link>
          </li>
          </ul>
        </div>

        {/* Social Media */}
        <div className="footer-social">
          <a href="https://www.facebook.com/share/HXinVBXZcniiW4FP/?mibextid=LQQJ4d" target="_blank" rel="noreferrer">
            <FaFacebookF />
          </a>
         
          <a href="https://www.linkedin.com/company/gifteng-aerial-solutions" target="_blank" rel="noreferrer">
            <FaLinkedinIn />
          </a>
          <a href="https://instagram.com" target="_blank" rel="noreferrer">
            <FaInstagram />
          </a>
        </div>

        {/* Newsletter */}
        <div className="footer-newsletter">
          <h3>Stay Updated</h3>
          <p>Subscribe to our newsletter to get the latest news and offers.</p>
          <form className="newsletter-form">
            <input type="email" placeholder="Your Email Address" required />
            <button type="submit">Subscribe</button>
          </form>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <p>&copy; 2024 GiftEng Aerial Solutions</p>
        <p>
          Email:{" "}
          <a href="mailto:giftengptyltd@gmail.com">giftengptyltd@gmail.com</a>
        </p>
        <p>
          Phone: <a href="tel:+27768486145">+27 768 486145</a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
